import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const Container = styled(Flex)`
  padding: 20px 25px 20px 15px;
  // border-bottom: 1px solid ${COLORS.GREY_T_90};
  width: 100%;
  //  background-color: #ffffff;
  //   z-index: 99;
  //   position: sticky !important;
  //   top: 0 !important;
`
export const Main = styled.div`
  position: sticky;
  top: 0;
  z-index: 1001;
`
export const LeftSection = styled(Flex)`
  gap: ${props => (props?.gap ? props.gap : '0px')};
`
export const RightSection = styled(Flex)`
  gap: 20px;
`
export const SectionName = styled(Flex)`
  gap: 10px;
`

export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #4d566e;
`
export const SectionWrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  height: 100%;
  margin-top: -11px;
`
export const MainWrapper = styled(Flex)`
  width: 100%;
  height: 82vh;
  overflow-y: auto;
  margin-top: 0px;
  background: #FAFAFB;
`;

export const DateClickText = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  padding: 0px 2px 2px 2px;
  color: #3249d7;
  cursor: pointer;
`

export const MiniCalWidth = styled.div`
  width: min-content;
  padding: 10px;
  position: relative;
  left: -35px;
`

export const CustomDiv = styled.div`
cursor: pointer;
`
export const CustomSpan = styled.div`
cursor: pointer;
`